import { queryOptions } from '@tanstack/react-query';
import type { DashboardRange, DashboardSummary } from '@upme/contracts';
import { api } from '../../app/api-client';

export const dashboardKey = ['admin', 'dashboard'] as const;

export const dashboardSummaryOptions = (range: DashboardRange) =>
  queryOptions({
    queryKey: [...dashboardKey, 'summary', range] as const,
    queryFn: () => api.get('admin/dashboard/summary', { searchParams: { range } }).json<DashboardSummary>(),
    // 60s — выровнено с шагом обновления виджетов.
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
